<template>
    <div class="user-role-list-name">
        <strong>{{ user.id }}</strong>
    </div>
</template>

<script lang="ts">
import type { User } from "@/types/types";
import type { PropType } from "vue";

export default {
    name: "UserRoleListName",
    props: {
        user: {
            type: Object as PropType<User>,
            required: true
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.user-role-list-name {
    &__icon {
        display: inline-block;
        padding: 0 8px 0 0;
    }
}
</style>
